module.exports = __webpack_public_path__ + "img/MMI_UTILITIES_BRANCO.2fc017b1.svg";